import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { map, pipe, switchMap } from 'rxjs';
import { ClientFeatureFlagName } from '../../model/client-model/client-feature-flag';
import { BackendFeatureFlagsService } from '../../services/backend/backend-feature-flags.service';

type BoardStore = {
  version: string | null;
  isVersionLoading: boolean;
  versionError: Error | null;
};

export const boardInitialState: BoardStore = {
  version: null,
  isVersionLoading: false,
  versionError: null,
};

export const BoardStore = signalStore(
  { providedIn: 'root' },
  withState(boardInitialState),
  withMethods((store) => {
    const backendFeatureFlagsService = inject(BackendFeatureFlagsService);

    return {
      loadVersion: rxMethod<{ boardId: string }>(
        pipe(
          switchMap(({ boardId }) => {
            patchState(store, { isVersionLoading: true });

            return backendFeatureFlagsService.getBoardAndTenantFeatureFlags(boardId);
          }),
          map((featureFlags) => {
            const allFeatureFlags = [...featureFlags.boardFeatureFlags, ...featureFlags.tenantFeatureFlags];
            const isV4 = allFeatureFlags.find((flag) => flag.name === ClientFeatureFlagName.DashboardV4);
            const isV3 = allFeatureFlags.find((flag) => flag.name === ClientFeatureFlagName.DashboardV3);

            if (isV3) {
              return 'V3';
            }

            if (isV4) {
              return 'V4';
            }

            return 'V5';
          }),
          tapResponse({
            next: (version: BoardStore['version']) => {
              patchState(store, { isVersionLoading: false, version });
            },
            error: (error: Error | HttpErrorResponse) => {
              console.error('Error loading version:', error);
              patchState(store, { isVersionLoading: false, versionError: error });
            },
          })
        )
      ),
    };
  })
);
